import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const DEFAULT_LANGUAGE = 'zh-CN';
export const SUPPORTED_LANGUAGES = [DEFAULT_LANGUAGE, 'en-US'];
export const LANGUAGE_OPTIONS = [
  { code: 'zh-CN', label: '中文' },
  { code: 'en-US', label: 'English' },
];

export const normalizeLanguage = (language: string = '') => {
  const normalized = language.toLowerCase();
  if (normalized === 'zh' || normalized.startsWith('zh-')) return 'zh-CN';
  if (normalized === 'en' || normalized.startsWith('en-')) return 'en-US';
  return DEFAULT_LANGUAGE;
};

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  return normalizeLanguage(window.localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE);
};

export function isLanguageSupported(language: string = '') {
  return /^(zh|en)(-|$)/i.test(language);
}

export function checkUrlLanguage(language: string) {
  const normalized = normalizeLanguage(language);
  if (isLanguageSupported(language) && normalized !== i18n.language) {
    return i18n.changeLanguage(normalized);
  }
  return Promise.resolve(i18n);
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LANGUAGES,
    lng: getInitialLanguage(),
    fallbackLng: 'en-US',
    load: 'currentOnly',
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

i18n.on('languageChanged', (language) => {
  const normalized = normalizeLanguage(language);
  if (language !== normalized) {
    i18n.changeLanguage(normalized);
    return;
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalized;
  }
  if (typeof window !== 'undefined') {
    const unityWindow = window as Window & { _UNITY_PARAMS?: { language: string } };
    if (unityWindow._UNITY_PARAMS) unityWindow._UNITY_PARAMS.language = normalized;
  }
});

export default i18n;
